import React from 'react'

import LinkComponent from '../../components/LinkComponent/LinkComponent'
import { contentStyling, topBanner } from './TopBanner.module.css'

const topBannerContent = {
  en: '🎁 Give the Gift of Beauty This Mother’s Day | Extra Value with Every Gift Card | Celebrate Her All Month Long',
  nl: '🎁 Give the Gift of Beauty This Mother’s Day | Extra Value with Every Gift Card | Celebrate Her All Month Long',
}

const topBannerLink = {
  en: '/en/mothersday',
  nl: '/en/mothersday',
}

const TopBanner = ({ lang }) => {
  return (
    <section className={topBanner}>
      {topBannerContent[lang] && (
        <LinkComponent className={contentStyling} src={topBannerLink[lang]}>
          {topBannerContent[lang]}
        </LinkComponent>
      )}
    </section>
  )
}

export default TopBanner
